module.exports = __webpack_public_path__ + "static/img/son2.ac5c33d9.jpg";